<script lang="ts" setup>
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';

onMounted(() => {
  const { token, returnTo } = useRoute().query;

  console.log('Processing Auth Callback ', returnTo, useRoute().query);
  useRouter().push(returnTo as string);
});
</script>
